// Escapes all special RegExp characters so a user-supplied string can be used safely as a literal pattern
export default function escapeRegExp(string: string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
